const RECENT_DECK_LIMIT = 3;

const normalizeTitle = (value) => String(value ?? "").trim();
const normalizeId = (value) => String(value ?? "").trim();

const normalizeDeck = (deck) => {
  if (Array.isArray(deck)) {
    const [title, , spreadsheetId] = deck;
    const normalizedSpreadsheetId = normalizeId(spreadsheetId);
    if (!normalizedSpreadsheetId) {
      return null;
    }
    return {
      title: normalizeTitle(title) || "Untitled deck",
      spreadsheetId: normalizedSpreadsheetId,
      lastOpenedAt: null,
    };
  }

  if (!deck || typeof deck !== "object") {
    return null;
  }

  const spreadsheetId = normalizeId(deck.spreadsheetId);
  if (!spreadsheetId) {
    return null;
  }

  return {
    title: normalizeTitle(deck.title) || "Untitled deck",
    spreadsheetId,
    lastOpenedAt:
      typeof deck.lastOpenedAt === "string" && deck.lastOpenedAt.trim()
        ? deck.lastOpenedAt
        : null,
  };
};

export const parseRecentDecks = (value) => {
  if (!value) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map(normalizeDeck)
      .filter(Boolean)
      .slice(0, RECENT_DECK_LIMIT);
  } catch (error) {
    return [];
  }
};

export const buildRecentDecksStorageValue = (decks = []) =>
  JSON.stringify(
    decks
      .map(normalizeDeck)
      .filter(Boolean)
      .slice(0, RECENT_DECK_LIMIT)
  );

export const upsertRecentDeck = (decks = [], nextDeck) => {
  const normalizedNextDeck = normalizeDeck(nextDeck);
  if (!normalizedNextDeck) {
    return decks.slice(0, RECENT_DECK_LIMIT);
  }

  const dedupedDecks = decks
    .map(normalizeDeck)
    .filter(Boolean)
    .filter((deck) => deck.spreadsheetId !== normalizedNextDeck.spreadsheetId);

  return [
    {
      ...normalizedNextDeck,
      lastOpenedAt: new Date().toISOString(),
    },
    ...dedupedDecks,
  ].slice(0, RECENT_DECK_LIMIT);
};
